/**
 * Belgian structured communication (OGM) for VKO / bank-transfer orders.
 *
 * Formula: "86" + 8-digit doknr (zero-padded) + modulus 97 check digits.
 * Example: doknr 1234 → 8600001234 % 97 = 52 → "860/0001/23452"
 *
 * @param {number|string} doknr - VKO document / order number
 * @returns {{ digits: string, display: string }}
 */
const generateStructuredMededeling = (doknr) => {
  const numericDoknr = String(doknr ?? "").replace(/\D/g, "");
  if (!numericDoknr) {
    throw new Error("doknr is required to generate structured mededeling");
  }

  const paddedDoknr = numericDoknr.padStart(8, "0").slice(-8);
  const base = `86${paddedDoknr}`;
  const checkMod = Number(base) % 97;
  // Belgian OGM: if modulus is 0, check digits are 97 (not 00).
  const check = String(checkMod === 0 ? 97 : checkMod).padStart(2, "0");
  const digits = `${base}${check}`;

  return {
    digits,
    display: `${digits.slice(0, 3)}/${digits.slice(3, 7)}/${digits.slice(7)}`,
  };
};

module.exports = {
  generateStructuredMededeling,
};
